import { render } from '@wordpress/element';
import Tabs from './components/Tabs';
import './index.css';

const GrayingSocieties = () => {
    return (
        <div id="interactive">
            <div id="main-container">
                <div id="interactive-header">
                    <p id="subtitle">
                        <em>% of population age 65 or older</em>
                    </p>
                </div>
                <Tabs />
            </div>

            <div id="source">
                Source: United Nations, Population Division of the Department of
                Economic and Social Affairs,
                <a href="http://esa.un.org/unpd/wpp/index.htm">
                    {' '}
                    World Population Prospects: The 2012 Revision
                </a>
            </div>
        </div>
    );
};

if (document.getElementById('js-graying-societies')) {
    render(
        <GrayingSocieties />,
        document.getElementById('js-graying-societies'),
    );
}
